import { EpiContent } from '@api/types';
import { ContentArea, SmartLink, Title } from '@components';
import { Box, ListItemText } from '@mui/material';
import { colors } from '@themes/colors';
import { Fragment } from 'react';
import { useMultilevelMenuContext } from './MultilevelMenuProvider';
type MultilevelSubMenuProps = {
  isVisible: boolean;
  content?: EpiContent;
};

export const MultilevelSubMenu: React.FC<MultilevelSubMenuProps> = ({
  isVisible,
  content,
}: MultilevelSubMenuProps) => {
  const { productData, openCategory } = useMultilevelMenuContext();
  return (
    <Fragment>
      {productData?.categories?.map((product) => {
        const isCategoryOpen =
          openCategory === product.code &&
          isVisible &&
          product?.nestedCategories &&
          product?.nestedCategories?.length > 0;
        return (
          <Box
            key={product.code}
            sx={{
              borderLeft: `2px solid ${colors.primary.mainGreen}`,
              py: 2,
              display: isCategoryOpen ? 'block' : 'none',
            }}
          >
            <ContentArea
              content={content}
              wrapperComponent={(props) => {
                return (
                  <Title
                    variant='h3'
                    sx={{
                      px: 6,
                    }}
                  >
                    {props.block.submenuTitle}
                  </Title>
                );
              }}
            />
            {product?.nestedCategories?.map((subCategory) => (
              <div key={subCategory.code}>
                <SmartLink
                  href={subCategory.url}
                  sx={{
                    color: colors.text.primary,
                    '&:hover': {
                      backgroundColor: colors.primary.lightGreen,
                    },
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <ListItemText
                    primary={subCategory.displayName}
                    sx={{ minWidth: '250px', cursor: 'pointer', px: 6 }}
                  />
                </SmartLink>
              </div>
            ))}
          </Box>
        );
      })}
    </Fragment>
  );
};
